<template lang='pug' src='./hero-home.pug'></template>

<script>
export default {
  props: ['props'],
  data () {
    return {
      active: false
    }
  },
  mounted () {
    if (!this.$store.state.loading) {
      setTimeout(() => {
        this.active = true
      }, 100)
    }
    if (this.$store.state.loading) {
      this.mounted()
    }
  }
}
</script>



// WEBPACK FOOTER //
// hero-home.vue?1fd2636a